import { FormControl, FormHelperText, InputLabel, Select } from '@mui/material';
import { SelectProps } from '@mui/material/Select/Select';
import React, { ReactElement } from 'react';

interface GtSelectProps extends Omit<SelectProps, 'error'> {
  error?: string;
  showError?: boolean;
}

export function GtSelect({
  children,
  className,
  error,
  showError,
  size,
  ...props
}: GtSelectProps): ReactElement {
  const hasError = showError !== undefined ? showError : !!error;

  const inputLabelProps =
    props.inputProps && props.inputProps.id
      ? {
          htmlFor: props.inputProps.id,
        }
      : {};

  return (
    <FormControl
      className={className}
      variant={props.variant}
      size={size}
      disabled={props.disabled}
      error={hasError}
      fullWidth={props.fullWidth}
    >
      <InputLabel {...inputLabelProps}>{props.label}</InputLabel>
      <Select {...props}>{children}</Select>

      <FormHelperText>{error}</FormHelperText>
    </FormControl>
  );
}
